import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import lodash from "lodash";
import { useObserver } from "mobx-react-lite";

import HandleBox from "./HandleBox";
import UnhandledBox from "./UnhandleBox";
import ModbusHandleBox from "./ModbusHandleBox";
import { AuthStoreContext } from "../../contexts";
import { firebaseFetchUserProfile } from "../../firebase/user";

/**
|--------------------------------------------------
| Default Props
|--------------------------------------------------
*/
AnalogList.defaultProps = {
  sensor: {},
  sensorDisplay: {},
};

export default function AnalogList(props) {
  const analogs = lodash.get(props, `sensor.status.analog`, []);
  const modbuses = lodash.get(props, `sensor.status.modbus`, []);

  /**
  |--------------------------------------------------
  | Contexts
  |--------------------------------------------------
  */
  const authStore = useContext(AuthStoreContext);

  /**
  |--------------------------------------------------
  | Handlers
  |--------------------------------------------------
  */
  async function onUpdateSub() {
    const userProfile = await firebaseFetchUserProfile(authStore.authUser.uid);
    authStore.setAuthUserProfile(userProfile);
  }

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  // Object.keys(analogs).map((e, i) => {
  //   if (i > 7) {
  //     delete analogs[e];
  //   }
  //   return "";
  // });

  // Object.keys(modbuses).map((e, i) => {
  //   if (i > 7) {
  //     delete modbuses[e];
  //   }
  //   return "";
  // });

  return useObserver(() => (
    <Grid container>
      <Grid container style={{ display: "flex", width: "100%" }}>
        <div className="flex flex-no-wrap sm:flex-wrap overflow-x-auto sm:overflow-hidden">
          {lodash.map(analogs, (item, key) => (
            <div
              key={`${item.name} ${key}`}
              className="w-full sm:w-1/4 min-h-64"
            >
              {item.handle ? (
                <HandleBox
                  key={key}
                  item={item}
                  analogKey={key}
                  sensorDisplay={props.sensorDisplay}
                  userProfile={authStore.authUserProfile}
                  user={authStore.authUser}
                  factoryID={props.factoryID}
                  dealerID={props.dealerID}
                  sensor={props.sensor}
                  onUpdateSub={onUpdateSub}
                />
              ) : (
                <UnhandledBox
                  key={key}
                  item={item}
                  analogKey={key}
                  sensorDisplay={props.sensorDisplay}
                />
              )}
            </div>
          ))}
          {lodash.map(modbuses, (item, key) => (
            <div
              key={`${item.name} ${key}`}
              className="w-full sm:w-1/4 min-h-64 "
            >
              {item.handle ? (
                <ModbusHandleBox
                  key={key}
                  item={item}
                  analogKey={key}
                  sensorDisplay={props.sensorDisplay}
                  userProfile={authStore.authUserProfile}
                  user={authStore.authUser}
                  factoryID={props.factoryID}
                  dealerID={props.dealerID}
                  sensor={props.sensor}
                  onUpdateSub={onUpdateSub}
                />
              ) : (
                <UnhandledBox
                  key={key}
                  item={item}
                  analogKey={key}
                  sensorDisplay={props.sensorDisplay}
                />
              )}
            </div>
          ))}
        </div>
      </Grid>
    </Grid>
  ));
}
